import { useSearchParams } from "react-router-dom";
import CompanyDirectory from "@/pages/CompanyDirectory";
import Suppliers from "@/pages/Suppliers";
import Customers from "@/pages/Customers";
import Distributors from "@/pages/Distributors";
import LandFreight from "@/pages/LandFreight";
import SeaFreight from "@/pages/SeaFreight";
import CoPackers from "@/pages/CoPackers";
import GlobalContactSearch from "@/components/GlobalContactSearch";

const TABS = [
  { key: "company", label: "Company Directory", testid: "contacts-tab-company" },
  { key: "suppliers", label: "Suppliers", testid: "contacts-tab-suppliers" },
  { key: "co-packers", label: "Co-Packers", testid: "contacts-tab-co-packers" },
  { key: "customers", label: "Customers", testid: "contacts-tab-customers" },
  { key: "distributors", label: "Distributors", testid: "contacts-tab-distributors" },
  { key: "land-freight", label: "Land Freight", testid: "contacts-tab-land-freight" },
  { key: "sea-freight", label: "Sea Freight", testid: "contacts-tab-sea-freight" },
];

export default function Contacts() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab");
  const tab = TABS.some((t) => t.key === raw) ? raw : "company";
  const seedQ = params.get("q") || "";
  const jump = (tabKey, term) => setParams({ tab: tabKey, q: term }, { replace: true });
  return (
    <div data-testid="contacts-page">
      <div className="mx-auto max-w-[1100px] px-6 pt-8 md:px-10 md:pt-12">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Contacts</p>
        <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
          <div className="inline-flex flex-wrap rounded-sm border border-slate-200 bg-slate-50 p-1" data-testid="contacts-tabs">
            {TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setParams({ tab: t.key }, { replace: true })}
                className={`rounded-sm px-4 py-1.5 text-sm font-semibold transition-colors ${tab === t.key ? "bg-white text-[#002FA7] shadow-sm" : "text-slate-500 hover:text-slate-800"}`}
                data-testid={t.testid}
              >
                {t.label}
              </button>
            ))}
          </div>
          <GlobalContactSearch onJump={jump} />
        </div>
      </div>
      <div className="-mt-4">
        {tab === "company" && <CompanyDirectory initialQuery={seedQ} />}
        {tab === "suppliers" && <Suppliers initialQuery={seedQ} />}
        {tab === "co-packers" && <CoPackers initialQuery={seedQ} />}
        {tab === "customers" && <Customers initialQuery={seedQ} />}
        {tab === "distributors" && <Distributors initialQuery={seedQ} />}
        {tab === "land-freight" && <LandFreight initialQuery={seedQ} />}
        {tab === "sea-freight" && <SeaFreight initialQuery={seedQ} />}
      </div>
    </div>
  );
}
